import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getPetugasTc = 'petugas-tc';
const getPetugasTcAktif = 'petugas-tc';
const getPetugasTcTidakAktif = 'petugas-tc';
const postPetugasTcUrl = 'petugas-tc';
const putPetugasTc = 'petugas-tc/';
const deletePetugasTc = 'petugas-tc/';
const getPetugasTcByIdTc = 'petugas-tc/test-center/'
const getPetugasTcById = 'petugas-tc/';
const exportPetugasTc = 'data-test-center-export';

class PetugasTcService {
    getPetugasTc(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getPetugasTc + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }

    getPetugasTcAktif(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getPetugasTcAktif + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&sortBy=id' + '&status=1',
            {
                headers: authHeader()
            });
    }

    getPetugasTcTidakAktif(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getPetugasTcTidakAktif + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&sortBy=id' + '&status=0',
            {
                headers: authHeader()
            });
    }

    postPetugasTc(formData) {   
        var form = new FormData();

        form.append("name", formData.name);
        form.append("username", formData.username);
        form.append("email", formData.email);
        form.append("noTelephone", formData.noTelephone);
        form.append("alamat", formData.alamat);
        form.append("password",formData.password);
        form.append("status", formData.status);
        form.append("dataTestCenter.idTc", formData.idTc);
        // 
        if (typeof formData.foto !== 'undefined') {
            form.append("foto", formData.foto);
        }
        
        return axios
        .post(
            API_URL + postPetugasTcUrl,
            form,
            {  headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
        );
    }

    putPetugasTc(id_user,formData) {
        var form = new FormData();

        form.append("name", formData.name);
        form.append("username", formData.username);
        form.append("email", formData.email);
        form.append("noTelephone", formData.noTelephone);
        form.append("alamat", formData.alamat);
        form.append("password",formData.password);
        form.append("status", formData.status);
        form.append("dataTestCenter.idTc", formData.idTc);
        // 
        if (typeof formData.foto !== 'undefined') {
            form.append("foto", formData.foto);
        }
        return axios
        .put(
            API_URL + putPetugasTc + id_user, 
            form,
            {  headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
        );
    }

    deletePetugasTc(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deletePetugasTc + formData.id,
                { headers: authHeader() }
            );
    }

    getPetugasTcByIdTc(idTc) {
        var headers = authHeader();

        return axios
        .get(
            API_URL + getPetugasTcByIdTc + idTc,
            { headers: authHeader() }
        );
    }

    getPetugasTcById(id) {
        var headers = authHeader();

        return axios
        .get(
            API_URL + getPetugasTcById + id,
            { headers: authHeader() }
        );
    }

    exportPetugasTcAktif() {
        return axios.get(API_URL + exportPetugasTc, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    exportPetugasTcTidakAktif() {
        return axios.get(API_URL + exportPetugasTc, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

}

export default new PetugasTcService();